import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    requestPasswordResetRequest,
    clearPasswordResetState,
} from "../../../redux/actions/emailActions";

const ForgotPasswordModal = ({
    onClose,
    resetLoading,
    resetRequestMessage,
    resetError,
    requestPasswordReset,
    clearResetState,
}) => {
    const [identifier, setIdentifier] = useState("");
    const isSuccess = Boolean(resetRequestMessage);

    useEffect(() => () => clearResetState(), [clearResetState]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (identifier.trim()) requestPasswordReset(identifier.trim());
    };

    return (
        <div className="cm-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="cm-card">
                <div className="cm-head">
                    <div className="cm-head-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            {isSuccess ? (
                                <path d="M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="rgba(255,255,255,0.9)" />
                            ) : (
                                <path d="M12 1C8.676 1 6 3.676 6 7v1H4a1 1 0 00-1 1v13a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1h-2V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4zm0 9a2 2 0 110 4 2 2 0 010-4z" fill="rgba(255,255,255,0.9)" />
                            )}
                        </svg>
                    </div>
                    <h2 className="cm-head-title">{isSuccess ? "Lien envoyé" : "Mot de passe oublié"}</h2>
                    <p className={`cm-head-sub${isSuccess ? " sent" : ""}`}>
                        {isSuccess
                            ? "Votre demande a bien été traitée"
                            : "Saisissez votre identifiant pour recevoir un lien de réinitialisation"}
                    </p>
                    <button className="cm-close" type="button" onClick={onClose} aria-label="Fermer">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                            <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                <div className="cm-body">
                    {!isSuccess ? (
                        <form onSubmit={handleSubmit}>
                            {resetError && <div className="cm-err">{resetError}</div>}
                            <label className="cm-label" htmlFor="reset-identifier">Identifiant ou email</label>
                            <div className="cm-field">
                                {/*<span className="cm-field-ico" aria-hidden="true">*/}
                                {/*    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">*/}
                                {/*        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" />*/}
                                {/*    </svg>*/}
                                {/*</span>*/}
                                <input
                                    id="reset-identifier"
                                    className="cm-input"
                                    type="text"
                                    placeholder="Username ou email"
                                    value={identifier}
                                    onChange={(e) => setIdentifier(e.target.value)}
                                    disabled={resetLoading}
                                    autoFocus
                                />
                            </div>
                            <button type="submit" className="cm-btn" disabled={resetLoading || !identifier.trim()}>
                                {resetLoading ? <><span className="cm-spin" />Envoi en cours...</> : <>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" /></svg>
                                    Envoyer le lien
                                </>}
                            </button>
                        </form>
                    ) : (
                        <div className="cm-success">
                            <div className="cm-success-ring">
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
                                    <circle cx="14" cy="14" r="12" stroke="rgba(42,92,169,.2)" strokeWidth="1.5" />
                                    <polyline className="cm-check-path" points="8,14 12,18 20,10" fill="none" stroke="#2a5ca9" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className="cm-success-badge">Email envoyé</div>
                            <h3 className="cm-success-title">Vérifiez votre boîte mail !</h3>
                            <p className="cm-success-desc">{resetRequestMessage}<br />Pensez à vérifier vos spams si besoin.</p>
                            <button className="cm-btn" type="button" onClick={onClose}>Compris, retour à la connexion</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    resetLoading: state.emails?.resetLoading || false,
    resetRequestMessage: state.emails?.resetRequestMessage || "",
    resetError: state.emails?.resetError || null,
});

const mapDispatchToProps = (dispatch) => ({
    requestPasswordReset: (identifier) => dispatch(requestPasswordResetRequest(identifier)),
    clearResetState: () => dispatch(clearPasswordResetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordModal);
